import { getUserDetails } from 'api/getUserDetails';
import axios from 'axios';
import { Specialisation } from 'models/business';
import { generateGetHeaders } from 'api/generateGetHeaders';
import { useQuery } from 'react-query';

export const useSpecialisations = (businessName: string) => {
  return useQuery<Specialisation[], Error>(
    'specialisations',
    async () => {
      const userDetails = await getUserDetails();
      const { data } = await axios.get(
        `${process.env.REACT_APP_API}/Portal/Specialisations`,
        generateGetHeaders(userDetails, businessName)
      );
      return data;
    },
    { refetchOnWindowFocus: true }
  );
};
